import SupportChat from "@/components/SupportChat";
import { useTranslation } from "react-i18next";

export default function AdminSupport() {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-3xl font-bold text-slate-900">{t("support.title")}</h1>
        <p className="text-slate-500 text-sm mt-1">{t("support.subtitle")}</p>
      </div>
      <SupportChat scope="merchant" />
    </div>
  );
}
